/*
 * File: AppointmentDetailLinks.js
 * Project: mp-mobile-app
 *
 * Created by jeddumire on 09/25/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates components for each appointment in the Patient Appointments list
 */
import React from "react";
import UILinkList from "components/ui/UILinkList";
import PropTypes from "prop-types";
import DateFormatter from "utils/DateFormatter";
import { ListItemText } from "@material-ui/core";
import { parseISO, format } from "date-fns";

const AppointmentDetailLinks = ({ appointments }) => {
  const getTitle = appointment => {
    return (
      <ListItemText
        primary={getPrimaryText(appointment)}
        secondary={appointment.type + "/" + appointment.status}
        primaryTypographyProps={{
          style: { color: getStatusColor(appointment.status) }
        }}
      />
    );
  };

  const getStatusColor = apptStatus => {
    switch (apptStatus) {
      case "Missed":
        return "red";

      case "Cancelled":
        return "blue";

      case "To Reschedule":
        return "purple";

      default:
        return "black";
    }
  };

  const getPrimaryText = appointment => {
    const date = DateFormatter.mdy(appointment.start);
    const time = format(parseISO(appointment.start), "hh:mm a");
    const duration = appointment.duration
      ? "(" + appointment.duration + " min)"
      : "";
    let string = date + "  " + time + " " + duration;
    if (appointment.isArchived) {
      string = string + " DELETED";
    }
    return string;
  };

  const linkTo = appointmentId => {
    if (!appointmentId) {
      return "";
    }
    return "/appointments/" + appointmentId;
  };

  const links = appointments.map(appointment => {
    const url = linkTo(appointment.appointmentId);
    return { primaryString: getTitle(appointment), url: url };
  });

  return <UILinkList includeFabPadding links={links} />;
};

AppointmentDetailLinks.propTypes = {
  appointments: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default AppointmentDetailLinks;
